module.exports = __webpack_public_path__ + "img/1.23098656.jpg";